import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenewalService = _resolveComponent("RenewalService")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "renewal-service-wrap renewal-service-drawer",
    title: "服务到期",
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: 1000,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_RenewalService, {
            key: 0,
            "is-private": ""
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "onClose"]))
}